require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-makinginroadsintotraditionallymaleindustries.json") })
        }
      }, "path---insights-makinginroadsintotraditionallymaleindustries");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-makinginroadsintotraditionallymaleindustries!./.cache/json/insights-makinginroadsintotraditionallymaleindustries.json
// module id = 1139
// module chunks = 231608221292675